export enum VirtualSportTypesEnum {
  HORSE_RACING = 54,
  GREYHOUNDS = 55,
  MARBLE_RACING = 118,
  CYCLING = 150,
  FOOTBALL_PRO = 173,
  PENALTY_KICKS = 174,
  FOOTBALL_LEAGUE = 188,
  DRAG_RACING = 209,
};

export const virtualSportTypeIds = Object.values(VirtualSportTypesEnum);
